import React from 'react';
import { SuggestedOpportunity } from 'types';

interface Props {
    opportunity: SuggestedOpportunity;
    isChild: boolean;
}

export default function SuggestedOpportunityTile({ opportunity, isChild }: Props) {
    return (
        <div className={`opp-suggestion-tile${isChild ? ' opp-suggestion-tile--child' : ''}`}>
            <p className='opp-suggestion-tile__title'>{opportunity.title}</p>
            {opportunity.description && (
                <p className='opp-suggestion-tile__desc'>{opportunity.description}</p>
            )}
        </div>
    );
}
